import WebixContextMenu from '../../grid/webixContextMenu';
import MassChangeContextMenu from '../../grid/massChangeContextMenu';

export default instance => {
  instance.attachEvent('onContextMenu', (taskId, linkId, event) => {
    WebixContextMenu.onContextMenu(taskId, linkId, event);
    MassChangeContextMenu.onContextMenu(taskId, linkId, event);
  });
};
